exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".field-module-root{min-width:100%}", ""]);

// Exports
exports.locals = {
	"root": "field-module-root"
};